module.exports = __webpack_public_path__ + "media/application/images/home/magazine-51e39544ca02cdc33025dc8bc958f79e.svg";